import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GameDetaileFunc } from "../../redux/actions";
import "./GameCard2.css";
import { useTranslation } from 'react-i18next';

// import NintendoStore from "./imaged/playstation-store.jpg";

// import img from "./image 1 copy.jpg";

function GameCard2(props) {
  const { t } = useTranslation(); // ดึงฟังก์ชันแปลจาก useTranslation


  return (
    <div >
      <div className="game mt-2">
        {props.element.images_local ? <img
          className="game-img"
          src={require(`../../assets/gameimage/${props.element.game_frontend_src}`)}

          alt={`${props.element.game_name}-IMG`}
        /> : <img
          className="game-img"
          src={`${props.element.game_frontend_src}`}
          alt={`${props.element.game_name}-IMG`}
        />
        }
        <div className="game-card">
          <div className="row">
            <div className="col-12 text-center">
              <button
                className="btn bg-success btn-sm text-white text-capitalize"
                onClick={() => { window.location.href = process.env.REACT_APP_URL }} //1 2 3 4 5
              >
                PLAY
              </button>
            </div>
            {/* <div className="col-12 text-center">
              <button
                className="btn-demo btn bg-secondary btn-sm text-white text-capitalize"
                onClick={() => { }} //1 2 3 4 5
              >
                DEMO
              </button>
            </div> */}
          </div>
        </div>
      </div>
      <p className="text-center text-capitalize m-0" style={{ fontSize: "14px", fontWeight: "bold", textDecoration: "none" }}>{props.element.game_name}</p>
    </div>
  );
}

export default GameCard2;
